/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIArticleVariation
 */
export interface APIArticleVariation {
    /**
     * 
     * @type {string}
     * @memberof APIArticleVariation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleVariation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleVariation
     */
    number: string;
}

/**
 * Check if a given object implements the APIArticleVariation interface.
 */
export function instanceOfAPIArticleVariation(value: object): value is APIArticleVariation {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    return true;
}

export function APIArticleVariationFromJSON(json: any): APIArticleVariation {
    return APIArticleVariationFromJSONTyped(json, false);
}

export function APIArticleVariationFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIArticleVariation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'number': json['number'],
    };
}

export function APIArticleVariationToJSON(value?: APIArticleVariation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'number': value['number'],
    };
}

